<div class="d-flex flex-column w-100 justify-content-center align-items-center">
    <p class="w-100 text-center font-bold mb-2 p-2" style="color: var(--primary); font-size: 1.1rem;"><i class='fa-solid fa-link'></i> Select Product to link to this page</p>
    <div class="d-flex flex-column" style="max-height: 60vh; overflow: scroll;">
      <div class="my-2 input-basic p-3">
       <input type = 'search' [(ngModel)]="searchKeyword" (keydown)="refreshView()" class="" placeholder="Search products"/>
      </div>
     
      <div *ngFor = "let product of allProducts" class="card mb-2" (click)="toggleProductLink(product)">
         <div class="card-body">
             <input type="checkbox" class="mr-1" [checked]="linkedProduct.has(product.id)"/>
             <span class="card-body">{{product.name}}</span>
         </div>
      </div>
    </div>
 </div>